import { useEffect, useState } from "react";

function ClientInfoCard({ show, object }) {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    setIsAdmin(show);
  }, [show]);

  if (!isAdmin) {
    return;
  }

  return (
    <>
      <div className="d-flex align-items-center gap-2 p-1 px-3 rounded-2 bg-light-subtle mb-2 border">
        <i className="bi bi-person-circle text-primary fs-1"></i>
        <div className="d-flex flex-column">
          <label className="fw-bold text-primary">{object?.name}</label>
          <p className="text-muted m-0">{object?.businessType}</p>
        </div>
      </div>
    </>
  );
}

export default ClientInfoCard;
